export const PROMOTION_STEPS = [
  "Basic Information",
  "Qualification Rules",
  "Reward Rules",
  "Reward Policy",
  "Restrictions",
  "Preview",
];

export const PROMOTION_STATUS = [
  { value: "draft", label: "Draft" },
  { value: "active", label: "Active" },
  { value: "disabled", label: "Disabled" },
];

export const PROMOTION_MODES = [
  { value: "automatic", label: "Automatic" },
  { value: "coupon", label: "Coupon Based" },
];

export const QUALIFICATION_TYPES = [
  { value: "flatDiscount", label: "Flat Discount" },
  { value: "percentageDiscount", label: "Percentage Discount" },
  { value: "spendAmount", label: "Spend Amount" },
  { value: "buyProduct", label: "Buy Product" },
  { value: "buyCategory", label: "Buy Category" },
  { value: "buyBrand", label: "Buy Brand" },
  { value: "buyCombo", label: "Buy Combo" },
  { value: "firstOrder", label: "First Order" },
];

export const REWARD_TYPES = [
  { value: "flatDiscount", label: "Flat Discount" },
  { value: "percentageDiscount", label: "Percentage Discount" },
  { value: "freeProduct", label: "Free Product" },
  { value: "freeDelivery", label: "Free Delivery" },
  { value: "comboPrice", label: "Combo Price" },
  { value: "fixedPrice", label: "Fixed Price (item priced at ₹X)" },
  { value: "rewardPoints", label: "Reward Points" },
  { value: "walletCredit", label: "Wallet Credit" },
];

export const REWARD_POLICIES = [
  { value: "fixedProduct", label: "Fixed Product" },
  { value: "customerSelect", label: "Customer Select" },
  { value: "cheapestFree", label: "Cheapest Free" },
  { value: "equalOrLowerPrice", label: "Equal or Lower Price" },

];

export const REPEAT_MODES = [
  { value: "NONE", label: "None" },
  { value: "UNLIMITED", label: "Unlimited" },
  { value: "LIMITED", label: "Limited" },
];

export const DELIVERY_TYPES = [
  { value: "delivery", label: "Delivery" },
  { value: "pickup", label: "Pickup" },
  { value: "dineIn", label: "Dine In" },
];

export const DEFAULT_STORES = [
  { value: "all", label: "All Stores" },
  { value: "main-kitchen", label: "Main Kitchen" },
  { value: "city-outlet", label: "City Outlet" },
];

export const DEFAULT_CITIES = [
  { value: "mumbai", label: "Mumbai" },
  { value: "delhi", label: "Delhi" },
  { value: "bangalore", label: "Bangalore" },
];

